import http from 'shared/utils/http';

export const fetchWayBillTblData = (params) => {
  //get by companyName, companyCode
  return http.get('/api/waybill', { ...params });
};
